import { useEffect, useRef, useContext, useState } from "react"
import { GpraContext } from "../../../context/gpraContext"
import { endpoints } from "../../../config/gpraApiEndpoints"
import { showMessage } from "../utils/utils"
import ServicesReceived1 from "../Forms/K/ServicesReceived/ServicesReceived1"
import { LoaderMedium } from "../../../components/Loaders"
import { INTERVIEW_SECTIONS } from "../types/interviewTypes"
import { UserContext } from "../../../context/userContext"

const ServicesReceived1Container = ({
  showToolBar,
  disabled,
  interview_id,
}) => {
  const { interview, handleSubmitGet, handleLoadPrev, loadCollection } =
    useContext(GpraContext)
  const userCtx = useContext(UserContext)

  const [isGettingServicesReceived, setIsGettingServicesReceived] =
    useState(true)

  const toast = useRef()

  useEffect(() => {
    setIsGettingServicesReceived(true)
    if (interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id) {
      handleSubmitGet(endpoints.GET_SERVICESRECEIVED_DATA, {
        gpra_interview_id: interview_id
          ? interview_id
          : interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id,
          organization_id: userCtx.session.user.organization_id,
        section: INTERVIEW_SECTIONS.SERVICES_RECEIVED_1,
      })
        .then((response) => {
          loadCollection(
            setValues(response.data),
            INTERVIEW_SECTIONS.SERVICES_RECEIVED_1
          )
          handleLoadPrev(false)
          setIsGettingServicesReceived(false)
        })
        .catch((error) => {
          showMessage(false, error, toast)
          handleLoadPrev(false)
          setIsGettingServicesReceived(false)
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const setValues = (data) => {
    return {
      gpra_k_mod_1: data?.form?.gpraKMod1 ?? 0,
      gpra_k_mod_2: data?.form?.gpraKMod2 ?? 0,
      gpra_k_mod_3: data?.form?.gpraKMod3 ?? 0,
      gpra_k_mod_4: data?.form?.gpraKMod4 ?? 0,
      gpra_k_mod_5: data?.form?.gpraKMod5 ?? 0,
      gpra_k_mod_6a: data?.form?.gpraKMod6a ?? 0,
      gpra_k_mod_6b: data?.form?.gpraKMod6b ?? 0,
      gpra_k_mod_6c: data?.form?.gpraKMod6c ?? 0,
      gpra_k_mod_6d: data?.form?.gpraKMod6d ?? 0,
      gpra_k_mod_6e: data?.form?.gpraKMod6e ?? 0,
      gpra_k_mod_6f: data?.form?.gpraKMod6f ?? 0,
      gpra_k_mod_6g: data?.form?.gpraKMod6g ?? 0,
      gpra_k_mod_6h: data?.form?.gpraKMod6h ?? 0,
      gpra_k_mod_6i: data?.form?.gpraKMod6i ?? 0,
      gpra_k_mod_7: data?.form?.gpraKMod7 ?? 0,
      gpra_k_mod_8a: data?.form?.gpraKMod8a ?? 0,
      gpra_k_mod_8b: data?.form?.gpraKMod8b ?? 0,
      gpra_k_mod_8c: data?.form?.gpraKMod8c ?? 0,
      gpra_k_mod_9: data?.form?.gpraKMod9 ?? 0,
      gpra_k_mod_10: data?.form?.gpraKMod10 ?? 0,
      gpra_k_mod_11: data?.form?.gpraKMod11 ?? 0,
      gpra_k_mod_11a: data?.form?.gpraKMod11a ?? "",
      gpra_k_id: data?.form?.gpraKId ?? 0,
      additional: data?.additional,
    }
  }
  if (isGettingServicesReceived) {
    return <LoaderMedium></LoaderMedium>
  }
  return (
    <>
      {!isGettingServicesReceived && (
        <ServicesReceived1 showToolBar={showToolBar} disabled={disabled} />
      )}
    </>
  )
}
export default ServicesReceived1Container
